"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TextArea = antd_1.Input.TextArea;
var DlgKeyValueEditor = /** @class */ (function (_super) {
    __extends(DlgKeyValueEditor, _super);
    function DlgKeyValueEditor(props) {
        return _super.call(this, props) || this;
    }
    DlgKeyValueEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                messageKey: data.messageKey,
                messageVal: data.messageVal,
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            messageKey: "",
            messageVal: "",
        });
        this.doReSetRules();
    };
    DlgKeyValueEditor.prototype.doReSetRules = function () {
        this.setState({
        // amount_rules: {isError: false },
        });
    };
    DlgKeyValueEditor.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgKeyValueEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        return true;
    };
    DlgKeyValueEditor.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.messageKey, this.state.messageVal);
            }
        }
    };
    DlgKeyValueEditor.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgKeyValueEditor.prototype.onMessageKeyChange = function (e) {
        this.props.controller.SetMessageKey(e.target.value);
    };
    //private onPromoCodeChange(e: React.ChangeEvent<HTMLInputElement>) {
    //    this.props.controller.SetPromoCode(e.target.value)
    //}
    DlgKeyValueEditor.prototype.onMessageValChange = function (e) {
        this.props.controller.SetMessageVal(e.target.value);
    };
    //private onIsUsePromoCodeChange(checked: boolean) {
    //    this.props.controller.SetIsHasPromoCode(checked)
    //}
    //private onIsImportantChange(checked: boolean) {
    //    this.props.controller.SetIsImportant(checked)
    //}
    DlgKeyValueEditor.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 280 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u041A\u043B\u044E\u0447"),
                React.createElement(antd_1.Input, { onChange: this.onMessageKeyChange.bind(this), value: this.state.messageKey }),
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435"),
                React.createElement(antd_1.Input, { onChange: this.onMessageValChange.bind(this), value: this.state.messageVal })));
    };
    return DlgKeyValueEditor;
}(React.Component));
exports.default = DlgKeyValueEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgKeyValueEditor.tsx
// module id = 2559
// module chunks = 0